var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gvl-thank-you" },
    [
      _vm._m(0),
      _c(
        "v-btn",
        {
          staticClass: "mt-5",
          attrs: { block: "", color: "primary" },
          on: { click: _vm.onRouteToHome }
        },
        [_vm._v("zurück zur Startseite")]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "text-center py-4" }, [
      _vm._v("Danke für Ihre Anfrage."),
      _c("br"),
      _vm._v(
        "Wir prüfen Ihren Antrag und setzen uns anschließend mit Ihnen in Verbindung"
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }